import { render, staticRenderFns } from "./MenuDispatcher.vue?vue&type=template&id=6fc33daf&"
import script from "./MenuDispatcher.vue?vue&type=script&lang=js&"
export * from "./MenuDispatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports